import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumberPague } from '../../../../../../../styles/primeReactConfig.js';

/**
 * @typedef {object} RecebivelDueDateSectionProps
 * @property {number|string|null} recebivelTipoVencimento
 * @property {(value: number|string|null) => void} setRecebivelTipoVencimento
 * @property {string} periodicidade
 * @property {(value: string) => void} setPeriodicidade
 */

/**
 * Bloco de vencimento e periodicidade do formulario de recebivel.
 *
 * @param {RecebivelDueDateSectionProps} props
 * @returns {JSX.Element}
 */
export default function RecebivelDueDateSection(props) {
    const {
        recebivelTipoVencimento,
        setRecebivelTipoVencimento,
        periodicidade,
        setPeriodicidade,
    } = props;

    return (
        <>
            <div className="w-full flex gap-5 items-center justify-center mt-3">
                <div className='flex flex-col w-full'>
                    <div className='flex flex-row w-full gap-4'>
                        <div className="flex w-full md:w-1/2  text-xl justify-end items-center">
                            <label htmlFor="recebivel_tipo_vencimento" className='h-fit'>Dia de Vencimento do boleto</label>
                        </div>
                        <div className="w-full md:w-1/2">
                            <InputNumber
                                value={recebivelTipoVencimento}
                                onValueChange={(e) => setRecebivelTipoVencimento(e.value)}
                                placeholder="ex: 7º dia"
                                suffix="º dia do mês"
                                pt={InputNumberPague}
                                min={1}
                                max={31}
                            />
                        </div>
                    </div>
                    <div className="w-full text-center">
                        <span className='text-xs font-bold'>(Dia de Vencimento de pagamento do boleto para o cliente.)</span>
                    </div>
                </div>
            </div>

            <div className="w-full flex gap-5 items-center justify-center mt-3">
                <label htmlFor="periodicidade" className='mt-2 mb-2 text-lg font-semibold'>Periodicidade</label>
                <div className="flex gap-4 md:flex-row flex-col">
                    <div className="flex items-center">
                        <RadioButton inputId="mensal" name="periodicidade" value="Mensal" onChange={(e) => setPeriodicidade(e.value)} checked={periodicidade === 'Mensal'} />
                        <label htmlFor="mensal" className="ml-2">Mensal</label>
                    </div>
                    <div className="flex items-center">
                        <RadioButton inputId="bimestral" name="periodicidade" value="Bimestral" onChange={(e) => setPeriodicidade(e.value)} checked={periodicidade === 'Bimestral'} />
                        <label htmlFor="bimestral" className="ml-2">Bimestral</label>
                    </div>
                    <div className="flex items-center">
                        <RadioButton inputId="trimestral" name="periodicidade" value="Trimestral" onChange={(e) => setPeriodicidade(e.value)} checked={periodicidade === 'Trimestral'} />
                        <label htmlFor="trimestral" className="ml-2">Trimestral</label>
                    </div>
                    <div className="flex items-center">
                        <RadioButton inputId="semestral" name="periodicidade" value="Semestral" onChange={(e) => setPeriodicidade(e.value)} checked={periodicidade === 'Semestral'} />
                        <label htmlFor="semestral" className="ml-2">Semestral</label>
                    </div>
                    <div className="flex items-center">
                        <RadioButton inputId="anual" name="periodicidade" value="Anual" onChange={(e) => setPeriodicidade(e.value)} checked={periodicidade === 'Anual'} />
                        <label htmlFor="anual" className="ml-2">Anual</label>
                    </div>
                </div>
            </div>
        </>
    );
}
